import type { IconNode } from '../types';

/**
 * @name calendar-arrow-right
 * @description Lucide SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTYgMnYzIiAvPgogIDxwYXRoIGQ9Im0xOCAyMSAzLTNoLTYiIC8+CiAgPHBhdGggZD0iTTIxIDEyLjM0VjVhMiAyIDAgMDAtMi0ySDVhMiAyIDAgMDAtMiAydjE0YTIgMiAwIDAwMiAyaDcuMzUiIC8+CiAgPHBhdGggZD0ibTIxIDE4LTMtMyIgLz4KICA8cGF0aCBkPSJNMyA5aDE4IiAvPgogIDxwYXRoIGQ9Ik04IDJ2MyIgLz4KPC9zdmc+Cg==) - https://lucide.dev/icons/calendar-arrow-right
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const CalendarArrowRight: IconNode = [
  ['path', { d: 'M16 2v3' }],
  ['path', { d: 'm18 21 3-3h-6' }],
  ['path', { d: 'M21 12.34V5a2 2 0 00-2-2H5a2 2 0 00-2 2v14a2 2 0 002 2h7.35' }],
  ['path', { d: 'm21 18-3-3' }],
  ['path', { d: 'M3 9h18' }],
  ['path', { d: 'M8 2v3' }],
];

export default CalendarArrowRight;
